import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { ToastContainerDirective } from 'ngx-toastr'
import { ToastService } from './toast.service'

/** This container component is used by ngx-toastr for injecting toasts in the DOM */
@Component({
  selector: 'ftr-toast-container',
  styleUrl: './toast-container.component.css',
  template: '<div toastContainer></div>',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class ToastContainerComponent implements OnInit {
  @ViewChild(ToastContainerDirective, { static: true }) toastContainer: ToastContainerDirective

  constructor(private readonly toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.container = this.toastContainer
  }
}
